exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ponta-balao{position:absolute;width:0;height:0;border-style:solid;border-color:transparent transparent #fff;top:2px;left:0;transform:translateY(0) rotate(45deg);border-width:20px 20px 20px 0}.similares-carrinho .collection-item{display:flex;flex-direction:column;gap:3px}.similares-carrinho .collection-item strong{color:#1565c0}.similares-carrinho .collection-item small{margin-top:4px;color:#607d8b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5872f0e8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/carrinhoView/CarrinhoView.vue
// module id = 286
// module chunks = 130